import React from "react";
import {
    Users,
    UserPlus,
    CreditCard,
    Wallet,
    ShieldCheck,
    Eye,
    TrendingUp,
    TrendingDown,
    ArrowRight,
    Plus,
    Search,
    UserCheck,
    Clock3,
    CheckCircle,
    AlertCircle,
    Crown,
    CalendarDays,
    MoreHorizontal,
} from "lucide-react";

const registrationData = [
    { month: "Apr", value: 42 },
    { month: "May", value: 58 },
    { month: "Jun", value: 51 },
    { month: "Jul", value: 73 },
    { month: "Aug", value: 65 },
    { month: "Sep", value: 84 },
];

const subscriptionData = [
    {
        plan: "Basic",
        members: 95,
        revenue: 95000,
        percentage: 34,
    },
    {
        plan: "Premium",
        members: 120,
        revenue: 180000,
        percentage: 43,
    },
    {
        plan: "Gold",
        members: 70,
        revenue: 210000,
        percentage: 23,
    },
];

const recentMembers = [
    {
        id: "JP00084",
        name: "Meena",
        gender: "Female",
        age: 27,
        location: "Erode",
        plan: "Premium",
        status: "Active",
        date: "05 Oct 2026",
    },
    {
        id: "JP00083",
        name: "Arun Kumar",
        gender: "Male",
        age: 30,
        location: "Perundurai",
        plan: "Gold",
        status: "Active",
        date: "05 Oct 2026",
    },
    {
        id: "JP00082",
        name: "Priya",
        gender: "Female",
        age: 26,
        location: "Erode",
        plan: "Basic",
        status: "Active",
        date: "04 Oct 2026",
    },
    {
        id: "JP00081",
        name: "Karthik",
        gender: "Male",
        age: 29,
        location: "Bhavani",
        plan: "Premium",
        status: "Pending",
        date: "04 Oct 2026",
    },
    {
        id: "JP00080",
        name: "Kavya",
        gender: "Female",
        age: 28,
        location: "Gobichettipalayam",
        plan: "Gold",
        status: "Active",
        date: "03 Oct 2026",
    },
];

const subscriptionActivity = [
    {
        member: "Arun Kumar",
        memberId: "JP00083",
        plan: "Gold",
        amount: 30000,
        date: "05 Oct 2026",
        status: "Success",
    },
    {
        member: "Meena",
        memberId: "JP00084",
        plan: "Premium",
        amount: 18000,
        date: "05 Oct 2026",
        status: "Success",
    },
    {
        member: "Priya",
        memberId: "JP00082",
        plan: "Basic",
        amount: 10000,
        date: "04 Oct 2026",
        status: "Success",
    },
    {
        member: "Kavya",
        memberId: "JP00080",
        plan: "Gold",
        amount: 30000,
        date: "03 Oct 2026",
        status: "Pending",
    },
];

function Dashboard() {
    const maxRegistration = Math.max(
        ...registrationData.map((item) => item.value)
    );

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 0,
        }).format(amount);
    };

    const handleQuickAction = (action) => {
        alert(`${action} page will be connected to the route.`);
    };

    return (
        <div className="branch-dashboard">

            {/* =========================================
                WELCOME HEADER
            ========================================= */}

            <div className="dashboard-welcome">

                <div className="welcome-content">

                    <div className="welcome-title">
                        <h1>Good Morning, Branch Admin 👋</h1>

                        <p>
                            Here's what's happening in your branch today.
                        </p>
                    </div>

                    <div className="branch-info">

                        <div className="branch-info-item">
                            <div className="branch-info-icon">
                                <Users size={17} />
                            </div>

                            <div>
                                <span>Branch</span>
                                <strong>Erode Main Branch</strong>
                            </div>
                        </div>

                        <div className="branch-info-divider" />

                        <div className="branch-info-item">
                            <div className="branch-info-icon calendar">
                                <CalendarDays size={17} />
                            </div>

                            <div>
                                <span>Today</span>
                                <strong>05 October 2026</strong>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            {/* =========================================
                SUMMARY CARDS
            ========================================= */}

            <div className="dashboard-summary-grid">

                {/* Total Members */}
                <div className="dashboard-summary-card blue">

                    <div className="summary-card-top">
                        <span>Total Members</span>

                        <div className="dashboard-summary-icon">
                            <Users size={21} />
                        </div>
                    </div>

                    <h2>420</h2>

                    <div className="summary-card-bottom">
                        <span className="growth positive">
                            <TrendingUp size={12} />
                            12.5%
                        </span>

                        <span>vs last month</span>
                    </div>

                </div>

                {/* New Registrations */}
                <div className="dashboard-summary-card pink">

                    <div className="summary-card-top">
                        <span>New Registrations</span>

                        <div className="dashboard-summary-icon">
                            <UserPlus size={21} />
                        </div>
                    </div>

                    <h2>84</h2>

                    <div className="summary-card-bottom">
                        <span className="growth positive">
                            <TrendingUp size={12} />
                            18.2%
                        </span>

                        <span>This month</span>
                    </div>

                </div>

                {/* Active Subscriptions */}
                <div className="dashboard-summary-card purple">

                    <div className="summary-card-top">
                        <span>Active Subscriptions</span>

                        <div className="dashboard-summary-icon">
                            <CreditCard size={21} />
                        </div>
                    </div>

                    <h2>285</h2>

                    <div className="summary-card-bottom">
                        <span className="growth positive">
                            <TrendingUp size={12} />
                            9.8%
                        </span>

                        <span>67.8% members</span>
                    </div>

                </div>

                {/* Wallet Balance */}
                <div className="dashboard-summary-card green">

                    <div className="summary-card-top">
                        <span>Wallet Balance</span>

                        <div className="dashboard-summary-icon">
                            <Wallet size={21} />
                        </div>
                    </div>

                    <h2>₹1,25,000</h2>

                    <div className="summary-card-bottom">
                        <span className="growth positive">
                            <TrendingUp size={12} />
                            14.3%
                        </span>

                        <span>Available balance</span>
                    </div>

                </div>

                {/* Pending Verification */}
                <div className="dashboard-summary-card orange">

                    <div className="summary-card-top">
                        <span>Pending Verification</span>

                        <div className="dashboard-summary-icon">
                            <ShieldCheck size={21} />
                        </div>
                    </div>

                    <h2>48</h2>

                    <div className="summary-card-bottom">
                        <span className="growth warning">
                            <Clock3 size={12} />
                            Attention
                        </span>

                        <span>Need verification</span>
                    </div>

                </div>

                {/* Profile Views */}
                <div className="dashboard-summary-card red">

                    <div className="summary-card-top">
                        <span>Profile Views Used</span>

                        <div className="dashboard-summary-icon">
                            <Eye size={21} />
                        </div>
                    </div>

                    <h2>1,284</h2>

                    <div className="summary-card-bottom">
                        <span className="growth negative">
                            <TrendingDown size={12} />
                            6.4%
                        </span>

                        <span>This month</span>
                    </div>

                </div>

            </div>

            {/* =========================================
                QUICK ACTIONS
            ========================================= */}

            <div className="dashboard-section-title">

                <div>
                    <h2>Quick Actions</h2>
                    <p>Frequently used branch operations</p>
                </div>

            </div>

            <div className="quick-actions-grid">

                <button
                    className="quick-action-card blue"
                    onClick={() =>
                        handleQuickAction("Add Member")
                    }
                >
                    <div className="quick-action-icon">
                        <UserPlus size={21} />
                    </div>

                    <div>
                        <strong>Add Member</strong>
                        <span>Create a new member profile</span>
                    </div>

                    <ArrowRight size={17} />
                </button>

                <button
                    className="quick-action-card green"
                    onClick={() =>
                        handleQuickAction("Profile Verification")
                    }
                >
                    <div className="quick-action-icon">
                        <UserCheck size={21} />
                    </div>

                    <div>
                        <strong>Verify Profiles</strong>
                        <span>Review pending profiles</span>
                    </div>

                    <ArrowRight size={17} />
                </button>

                <button
                    className="quick-action-card pink"
                    onClick={() =>
                        handleQuickAction("Find Matches")
                    }
                >
                    <div className="quick-action-icon">
                        <Search size={21} />
                    </div>

                    <div>
                        <strong>Find Matches</strong>
                        <span>Search suitable profiles</span>
                    </div>

                    <ArrowRight size={17} />
                </button>

                <button
                    className="quick-action-card orange"
                    onClick={() =>
                        handleQuickAction("Recharge Wallet")
                    }
                >
                    <div className="quick-action-icon">
                        <Wallet size={21} />
                    </div>

                    <div>
                        <strong>Recharge Wallet</strong>
                        <span>Add money to branch wallet</span>
                    </div>

                    <ArrowRight size={17} />
                </button>

            </div>

            {/* =========================================
                REGISTRATION + SUBSCRIPTION
            ========================================= */}

            <div className="dashboard-two-column">

                {/* Registration Chart */}
                <div className="dashboard-panel">

                    <div className="dashboard-panel-header">

                        <div>
                            <h3>Member Registration Overview</h3>
                            <p>
                                Monthly registration performance
                            </p>
                        </div>

                        <button className="panel-more-btn">
                            <MoreHorizontal size={18} />
                        </button>

                    </div>

                    <div className="registration-chart">

                        {registrationData.map((item) => {

                            const height =
                                (item.value /
                                    maxRegistration) *
                                100;

                            return (
                                <div
                                    className="dashboard-chart-column"
                                    key={item.month}
                                >

                                    <div className="dashboard-chart-value">
                                        {item.value}
                                    </div>

                                    <div className="dashboard-chart-track">

                                        <div
                                            className="dashboard-chart-bar"
                                            style={{
                                                height: `${height}%`,
                                            }}
                                        />

                                    </div>

                                    <span>
                                        {item.month}
                                    </span>

                                </div>
                            );
                        })}

                    </div>

                    <div className="chart-footer">

                        <div>
                            <strong>84</strong>
                            <span>Registrations this month</span>
                        </div>

                        <div className="chart-growth">
                            <TrendingUp size={14} />
                            18.2%
                        </div>

                    </div>

                </div>

                {/* Subscription Overview */}
                <div className="dashboard-panel">

                    <div className="dashboard-panel-header">

                        <div>
                            <h3>Subscription Overview</h3>
                            <p>
                                Current plan distribution
                            </p>
                        </div>

                        <button className="panel-more-btn">
                            <MoreHorizontal size={18} />
                        </button>

                    </div>

                    <div className="subscription-dashboard-list">

                        {subscriptionData.map((item) => (
                            <div
                                className="dashboard-subscription-row"
                                key={item.plan}
                            >

                                <div className="dashboard-plan-info">

                                    <div
                                        className={`dashboard-plan-dot ${item.plan.toLowerCase()}`}
                                    />

                                    <div>
                                        <strong>
                                            {item.plan}
                                        </strong>

                                        <span>
                                            {item.members} members
                                        </span>
                                    </div>

                                </div>

                                <div className="dashboard-plan-progress">

                                    <div className="dashboard-plan-track">
                                        <div
                                            className={`dashboard-plan-fill ${item.plan.toLowerCase()}`}
                                            style={{
                                                width: `${item.percentage}%`,
                                            }}
                                        />
                                    </div>

                                </div>

                                <div className="dashboard-plan-value">
                                    {item.percentage}%
                                </div>

                            </div>
                        ))}

                    </div>

                    <div className="subscription-total">

                        <div>
                            <span>Total Subscription Revenue</span>
                            <strong>
                                {formatCurrency(490000)}
                            </strong>
                        </div>

                        <div className="subscription-members-count">
                            <CreditCard size={15} />
                            285 Members
                        </div>

                    </div>

                </div>

            </div>

            {/* =========================================
                VERIFICATION + WALLET
            ========================================= */}

            <div className="dashboard-two-column">

                {/* Verification */}
                <div className="dashboard-panel">

                    <div className="dashboard-panel-header">

                        <div>
                            <h3>Profile Verification</h3>
                            <p>
                                Current verification status
                            </p>
                        </div>

                        <button
                            className="view-all-btn"
                            onClick={() =>
                                handleQuickAction(
                                    "Profile Verification"
                                )
                            }
                        >
                            View All
                            <ArrowRight size={14} />
                        </button>

                    </div>

                    <div className="verification-dashboard-grid">

                        <div className="verification-dashboard-card verified">

                            <div className="verification-dashboard-icon">
                                <CheckCircle size={19} />
                            </div>

                            <div>
                                <strong>285</strong>
                                <span>Verified</span>
                            </div>

                        </div>

                        <div className="verification-dashboard-card pending">

                            <div className="verification-dashboard-icon">
                                <Clock3 size={19} />
                            </div>

                            <div>
                                <strong>48</strong>
                                <span>Pending</span>
                            </div>

                        </div>

                        <div className="verification-dashboard-card rejected">

                            <div className="verification-dashboard-icon">
                                <AlertCircle size={19} />
                            </div>

                            <div>
                                <strong>12</strong>
                                <span>Rejected</span>
                            </div>

                        </div>

                    </div>

                    <div className="verification-dashboard-progress">

                        <div className="verification-progress-heading">
                            <span>Verification Completion</span>
                            <strong>82.6%</strong>
                        </div>

                        <div className="verification-track">
                            <div
                                className="verification-fill"
                                style={{
                                    width: "82.6%",
                                }}
                            />
                        </div>

                    </div>

                </div>

                {/* Wallet */}
                <div className="dashboard-panel wallet-dashboard-panel">

                    <div className="dashboard-panel-header">

                        <div>
                            <h3>Wallet Overview</h3>
                            <p>
                                Branch wallet summary
                            </p>
                        </div>

                        <button
                            className="view-all-btn"
                            onClick={() =>
                                handleQuickAction(
                                    "Wallet"
                                )
                            }
                        >
                            Manage
                            <ArrowRight size={14} />
                        </button>

                    </div>

                    <div className="wallet-balance-box">

                        <div className="wallet-balance-icon">
                            <Wallet size={22} />
                        </div>

                        <div>
                            <span>Available Balance</span>
                            <strong>₹1,25,000</strong>
                        </div>

                    </div>

                    <div className="wallet-stat-grid">

                        <div>
                            <span>Total Recharged</span>
                            <strong>₹7,50,000</strong>
                        </div>

                        <div>
                            <span>Used for Subscriptions</span>
                            <strong>₹6,25,000</strong>
                        </div>

                    </div>

                    <button
                        className="wallet-recharge-btn"
                        onClick={() =>
                            handleQuickAction(
                                "Recharge Wallet"
                            )
                        }
                    >
                        <Plus size={16} />
                        Recharge Wallet
                    </button>

                </div>

            </div>

            {/* =========================================
                RECENT MEMBERS + SUBSCRIPTIONS
            ========================================= */}

            <div className="dashboard-two-column">

                {/* Recent Members */}
                <div className="dashboard-panel">

                    <div className="dashboard-panel-header">

                        <div>
                            <h3>Recent Members</h3>
                            <p>
                                Latest member registrations
                            </p>
                        </div>

                        <button
                            className="view-all-btn"
                            onClick={() =>
                                handleQuickAction(
                                    "Members"
                                )
                            }
                        >
                            View All
                            <ArrowRight size={14} />
                        </button>

                    </div>

                    <div className="recent-members-list">

                        {recentMembers.map((member) => (
                            <div
                                className="recent-member-row"
                                key={member.id}
                            >

                                <div className="recent-member-avatar">
                                    {member.name.charAt(0)}
                                </div>

                                <div className="recent-member-info">

                                    <div className="recent-member-name">
                                        <strong>
                                            {member.name}
                                        </strong>

                                        <span>
                                            {member.id}
                                        </span>
                                    </div>

                                    <div className="recent-member-meta">
                                        <span>
                                            {member.age} Years
                                        </span>

                                        <span>
                                            {member.location}
                                        </span>

                                        <span>
                                            {member.date}
                                        </span>
                                    </div>

                                </div>

                                <div className="recent-member-plan">

                                    <span
                                        className={`plan-status ${member.plan.toLowerCase()}`}
                                    >
                                        {member.plan}
                                    </span>

                                    <span
                                        className={`member-status ${member.status.toLowerCase()}`}
                                    >
                                        {member.status}
                                    </span>

                                </div>

                            </div>
                        ))}

                    </div>

                </div>

                {/* Subscription Activity */}
                <div className="dashboard-panel">

                    <div className="dashboard-panel-header">

                        <div>
                            <h3>Recent Subscription Activity</h3>
                            <p>
                                Latest member subscriptions
                            </p>
                        </div>

                        <button
                            className="view-all-btn"
                            onClick={() =>
                                handleQuickAction(
                                    "Payments"
                                )
                            }
                        >
                            View All
                            <ArrowRight size={14} />
                        </button>

                    </div>

                    <div className="subscription-activity-list">

                        {subscriptionActivity.map(
                            (item, index) => (
                                <div
                                    className="subscription-activity-row"
                                    key={index}
                                >

                                    <div
                                        className={`activity-plan-icon ${item.plan.toLowerCase()}`}
                                    >
                                        <Crown size={16} />
                                    </div>

                                    <div className="activity-info">

                                        <div>
                                            <strong>
                                                {item.member}
                                            </strong>

                                            <span>
                                                {item.memberId}
                                            </span>
                                        </div>

                                        <small>
                                            {item.plan} Plan •{" "}
                                            {item.date}
                                        </small>

                                    </div>

                                    <div className="activity-amount">

                                        <strong>
                                            {formatCurrency(
                                                item.amount
                                            )}
                                        </strong>

                                        <span
                                            className={
                                                item.status ===
                                                "Success"
                                                    ? "success"
                                                    : "pending"
                                            }
                                        >
                                            {item.status}
                                        </span>

                                    </div>

                                </div>
                            )
                        )}

                    </div>

                </div>

            </div>

        </div>
    );
}

export default Dashboard;